import { purchasedGoodsRoutes } from '@app/purchased-goods/purchased-goods-routes';
import { Button } from '@shared/components/ui/button';
import { generatePath, useNavigate } from 'react-router-dom';

export default function PurchasedGoodsImportPageToolbar() {
  const navigate = useNavigate();
  return (
    <Button
      size="sm"
      data-testid="new-import-button"
      onClick={() =>
        navigate(generatePath(purchasedGoodsRoutes.PURCHASED_GOODS_IMPORT))
      }
    >
      New import
    </Button>
  );
}
